import { HttpContentFiles } from '../models/content-interface';
import { api } from '../utils/api';
import { AxiosResponse } from 'axios';

export const ContentApi = {
  getContentFiles: async (qs:string): Promise<HttpContentFiles> => {
    let odata_result = await api.get(`odata/ContentFiles${qs}`);
	return {
	  count: odata_result['@odata.count'],
	  entries: odata_result.value
	};
  },
  getContentTypes: async (): Promise<string[]> => {
	return await api.get(`Content/GroupLabels`);
  },  
  getServiceTypes: async (): Promise<string[]> => {
	return await api.get(`Content/ServiceTypes`);
  },
};